import { render, staticRenderFns } from "./subtitle.vue?vue&type=template&id=6082295c&scoped=true&"
import script from "./subtitle.vue?vue&type=script&lang=js&"
export * from "./subtitle.vue?vue&type=script&lang=js&"
import style0 from "./subtitle.vue?vue&type=style&index=0&id=6082295c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6082295c",
  null
  
)

export default component.exports